import { useTheme, Card, CardContent, Typography } from "@mui/material";

interface SupplierDetailCardProps {
  title: string;
  text: string;
}

const SupplierDetailCard = ({ title, text }: SupplierDetailCardProps) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        width: "100%",
        p: 1,
        border: `1px solid ${theme.palette.primary.main}`,
      }}
    >
      <CardContent>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "600",
            color: "primary.main",
            fontSize: "1.4rem",
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "500",
            color: "primary.main",
            fontSize: "1.2rem",
          }}
        >
          {text}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default SupplierDetailCard;
